<section class="users-view">
  <!-- Media object starts -->
  <div class="row">
    <div class="col-12 col-sm-7">
      <div class="media d-flex align-items-center">
        <div *ngIf="!jobData?.image"
                      [class.initial-alpha]="!jobData?.image"
                      class="users-avatar-shadow rounded mr-1 ml-0 bg-p bg-primary"
                    >
                      <div class="avatar-content">
                        {{jobData?.name |titlecase| shortName}}
                      </div>
        </div>
        <div class="media-body ml-3">
          <h4>
            <span class="users-view-name mr-1">{{ jobData?.name | titlecase}}</span>
            <!-- <span class="text-muted font-medium-1">
              <span>@</span>
              <span class="users-view-username">dean3004</span>
            </span> -->
          </h4>
          <span class="mr-1">ID:</span>
          <span class="users-view-id">{{ jobData?._id.slice( jobData?.user_id?._id.length -6)}}</span>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-5 d-flex justify-content-end align-items-center">
      <!-- <a href="javaScript:void(0);" class="btn btn-sm bg-light-secondary mr-2
        px-3 py-1"><i class="ft-book-open font-medium-3"></i></a> -->
      <!-- <a  class="btn btn-sm bg-light-secondary mr-2
        px-3 py-1" (click)="openModalAddPayment(myModalPayment,jobData?._id)">Add Payment</a> -->
        <a class="btn btn-sm bg-light-secondary mr-2
                px-3 py-1" (click)="openAddModal(myModalPayment,'add new',payment_data[0])">Add Payment</a>
      <a [routerLink]="['/jobs/edit',jobData?._id]" class="btn btn-sm btn-primary px-3
        py-1">Edit</a>
    </div>
  </div>
  <!-- Media object ends -->

  <div class="row">
    <div class="col-12">
      <!-- Card data starts -->
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-xl-12 users-module">
                <div class="table-responsive">
                  <table class="table mb-0">
                    <thead>
                      <tr>
                        <!-- <th>Total Fee</th> -->
                        
                        <th>Net Amount</th>
                        <th>Total Paid</th>
                        <th>Paid Amount</th>
                        <th>Pending Amount</th>
                        <th>Mode</th>
                        <th>Status</th>
                        <th>Due Date</th>
                        <th>Payment Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let payment of payment_data">
                                                
                        <td>
                          <span>{{ payment.job_id.projectbudget |  currency:'USD':'symbol':'1.0-0' }}</span>
                        </td>
                        <td>
                          <span>{{ payment.TotalAmount |  currency:'USD':'symbol':'1.0-0' }}</span>
                        </td>
                        <td>
                          <span
                            class="badge bg-light-success"  placement="top"
                            ngbTooltip="{{payment?.payment_notes}}">{{ payment?.PaidAmount |  currency:'USD':'symbol':'1.0-0' }}</span>
                        </td>
                        <td>
                          <span
                            class="badge bg-light-danger">{{ payment?.TotalPendingAmount |  currency:'USD':'symbol':'1.0-0' }}</span>
                        </td>
                        <td>
                          <span>{{ payment?.mode[0]?.displayname }}</span>
                        </td>
                        <td>
                          <span *ngIf="payment?.payment_status =='due'" class="badge bg-light-primary">{{ payment?.payment_status }}</span>
                          <span *ngIf="payment?.payment_status =='received'" class="badge bg-light-success">{{ payment?.payment_status }}</span>

                        </td>
                        <td>
                          <span *ngIf="payment?.payment_status =='due'" [ngClass]="{'danger':payment?.payment_date}">{{ payment?.payment_date | date :'mediumDate' }}</span>
                          <span *ngIf="payment?.payment_status !=='due'" style="margin-left: 20px;">-</span>
                        </td>
                        <td>
                          <span *ngIf="payment?.payment_status =='received'">{{ payment?.payment_date | date :'mediumDate' }}</span>
                          <span *ngIf="payment?.payment_status =='due'">{{ payment?.payment_date | date :'mediumDate' }}</span>
                        </td>
                        <td>
                          <i class="ft-edit text-primary cursor-pointer mr-2" (click)="openAddModal(myModalPayment,'update',payment)"></i>
                          <i *ngIf="user_role.roles =='admin' || user_role.roles =='employee'" class="ft-trash-2 text-danger cursor-pointer" (click)="confirmDelete(payment?._id)"></i>
                        </td>
                      </tr>
                      <p *ngIf="payment_data.length<1" style="color:red">Data Not Found</p>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Card data ends -->
    </div>
    <div class="col-12">
      <!-- User detail starts -->
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <div class="row bg-primary bg-lighten-4 rounded mb-3 mx-1
              text-center text-md-left">
              <div class="col-12 col-sm-2 p-3 d-flex align-itms-center firstdiv">
                <h6 class="primary align-self-center mb-0 mx-1">Registered:</h6>
                <span class="font-large-1 primary">{{jobData?.created_at | date :'shortDate'}}</span>
                <span *ngIf="!jobData?.created_at" class="font-large-1 primary">Data Not Found</span>
              </div>
              <div class="col-12 col-sm-2 p-3 d-flex align-itms-center firstdiv">
                <h6 class="primary align-self-center mb-0 mx-1">Latest Activity:</h6>
                <span class="font-large-1 primary">{{jobData?.updated_at | date :'shortDate'}}</span>
                <span class="font-large-1 primary" *ngIf="!jobData?.updated_at">Data Not Found</span>
              </div>
              <!-- <div class="col-12 col-sm-2 p-3 d-flex align-itms-center firstdiv">
                <h6 class="primary align-self-center mb-0 mx-1">Role:</h6>
                <span class="font-large-1 primary">{{jobData?.user_id?.roles}}</span>
                <span class="font-large-1 primary" *ngIf="!jobData?.user_id?.roles">Data Not Found</span>
              </div> -->
              <div class="col-12 col-sm-2 p-3 d-flex align-itms-center firstdiv">
                <h6 class="primary align-self-center mb-0 mx-1">Status:</h6>
                <span class=" font-large-1 badge bg-light-success users-view-status">{{jobData?.status[0]?.displayname}}</span>
                <span class="font-large-1 primary" *ngIf="!jobData?.status[0]?.displayname">Data Not Found</span>
              </div>
              <!-- <div class="col-12 col-sm-2 p-3 d-flex align-itms-center firstdiv">
                <h6 class="primary align-self-center mb-0 mx-1">Verified:</h6>
                <span class="font-large-1 primary">Yes</span>                  
              </div> -->
            </div>
            <h5 class="mb-2 text-bold-500"><i class="ft-info mr-2"></i>
              Job Info</h5>
            <div class="table-responsive">
              <table class="table table-borderless">
                <tbody>
                  <tr>
                    <td>Project Name:</td>
                    <td class="users-view-name">
                        <span>{{jobData?.name |titlecase}}</span>
                        <span *ngIf="!jobData?.name">Data Not Found</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Project Alert:</td>
                    <td class="users-view-name">
                        <span class="badge badge-pill bg-light-success text-capitalize mr-1" [ngClass]="{'bg-light-danger':jobData?.isalert=='yes'}">{{jobData?.isalert |titlecase}}</span>
                        <span *ngIf="!jobData?.isalert">Data Not Found</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Project Priority:</td>
                    <td class="users-view-name">
                        <span>{{jobData?.priority[0]?.displayname}}</span>
                        <span *ngIf="!jobData?.priority[0]?.displayname">Data Not Found</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Skills:</td>
                    <td class="users-view-name">
                        <div  *ngFor="let item of jobData?.skills ; let i as index; last as isLast">
                          <span>{{item.displayname}}</span>
                        </div> 
                        <span *ngIf="!jobData?.skills">Data Not Found</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Project Source:</td>
                    <td class="users-view-name">
                        <div  *ngFor="let item of jobData?.source ; let i as index; last as isLast">
                          <span>{{item?.displayname}}</span>
                        </div> 
                        <span *ngIf="!jobData?.source">Data Not Found</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Project Tag:</td>
                    <td class="users-view-name">
                          <span *ngIf="jobData?.channel?.name">{{jobData?.channel?.name}}</span>
                        <span *ngIf="!jobData?.channel?.name">Data Not Found</span>
                    </td>
                  </tr>  
                  <tr>
                    <td>Technology:</td>
                    <td class="users-view-name">
                        <div  *ngFor="let item of jobData?.technology; let i as index; last as isLast">
                          <span>{{item?.displayname}}</span>
                        </div> 
                        <span *ngIf="!jobData?.technology">Data Not Found</span>
                    </td>
                  </tr>
                  <tr>
                    <td>References:</td>
                    <td class="users-view-name">
                        <span class="badge badge-pill text-capitalize bg-light-primary mr-1" *ngFor="let item of jobData?.references ; let i as index; last as isLast">
                          <a [href]="item.links" target="_blank">
                            {{item.name}}
                          </a>
                        </span> 
                        <span *ngIf="!jobData?.references">Data Not Found</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Hunting By:</td>
                    <td class="users-view-name">
                        <div  *ngFor="let item of jobData?.hunting_by ; let i as index; last as isLast">
                          <span>
                            {{item?.name}}
                          </span>
                          <span *ngIf="item.length>1 && !isLast">,</span>
                        </div> 
                        <span *ngIf="!jobData?.hunting_by">Data Not Found</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Farming By:</td>
                    <td class="users-view-name">
                        <div *ngFor="let item of jobData?.farming_by ; let i as index; last as isLast">
                          {{item?.name}}
                          <span *ngIf="item.length>1 && !isLast">,</span>
                        </div> 
                        <span *ngIf="!jobData?.farming_by">Data Not Found</span>
                    </td>
                  </tr>
                  <tr>
                    <td>Notes:</td>
                    <td  [innerText]="jobData?.notes"></td>
                    <td *ngIf="!jobData?.notes">Data Not Found</td>
                  </tr>   
                  <tr>
                    <td>Admin Notes: </td>
                    <td  [innerText]="jobData?.admin_notes"></td>
                    <td *ngIf="!jobData?.admin_notes">Data Not Found</td>
                  </tr>                
                </tbody>
              </table>
            </div>
             <h5 class="mb-2 text-bold-500"><i class="ft-info mr-2"></i>
                Job Audit Info</h5>
              <div class="table-responsive">
                <table class="table table-borderless m-0">
                  <tbody>
                    <tr>
                      <td>Sprints:</td>
                      <td>
                        <span *ngIf="jobData?.sprints?.name">{{jobData?.sprints?.name}}</span>
                        <span *ngIf="!jobData?.sprints?.name">Data Not Found</span>
                      </td>
                    </tr>
                    <tr>
                      <td>MOM:</td>
                      <td>
                        <span *ngIf="jobData?.mom?.name">{{jobData?.mom?.name}}</span>
                        <span *ngIf="!jobData?.mom?.name">Data Not Found</span>
                      </td>
                    </tr>
                    <tr>
                      <td>BitBucket:</td>
                      <td>
                        <span *ngIf="jobData?.bitbucket?.name">{{jobData?.bitbucket?.name}}</span>
                        <span *ngIf="!jobData?.bitbucket?.name">Data Not Found</span>
                      </td>
                    </tr>
                    <tr>
                      <td>KPI:</td>
                      <td>
                        <span *ngIf="jobData?.kpi?.name">{{jobData?.kpi?.name}}</span>
                        <span *ngIf="!jobData?.kpi?.name">Data Not Found</span>
                      </td>
                    </tr>
                    <tr>
                      <td>Communication:</td>
                      <td>
                        <span *ngIf="jobData?.Communication?.name">{{jobData?.Communication?.name}}</span>
                        <span *ngIf="!jobData?.Communication?.name">Data Not Found</span>
                      </td>
                    </tr>
                    <tr>
                      <td>Reports:</td>
                      <td>
                        <span *ngIf="jobData?.reports?.name">{{jobData?.reports?.name}}</span>
                        <span *ngIf="!jobData?.reports?.name">Data Not Found</span>
                      </td>
                    </tr>
                    <tr>
                      <td>Work Dairy:</td>
                      <td>
                        <span *ngIf="jobData?.workdairy?.name">{{jobData?.workdairy?.name}}</span>
                        <span *ngIf="!jobData?.workdairy?.name">Data Not Found</span>
                      </td>
                    </tr>
                    <tr>
                      <td>Demo:</td>
                      <td>
                        <span *ngIf="jobData?.demo?.name">{{jobData?.demo?.name}}</span>
                        <span *ngIf="!jobData?.demo?.name">Data Not Found</span>
                      </td>
                    </tr>
                    <tr>
                      <td>FRS/DMS:</td>
                      <td>
                        <span *ngIf="jobData?.dmsfrs?.name">{{jobData?.dmsfrs?.name}}</span>
                        <span *ngIf="!jobData?.dmsfrs?.name">Data Not Found</span>
                      </td>
                    </tr>
                    <tr>
                      <td>QA:</td>
                      <td>
                        <span *ngIf="jobData?.qa?.name">{{jobData?.qa?.name}}</span>
                        <span *ngIf="!jobData?.qa?.name">Data Not Found</span>
                      </td>
                    </tr>
                    <tr>
                      <td>CRequest:</td>
                      <td>
                        <span *ngIf="jobData?.crequest?.name">{{jobData?.crequest?.name}}</span>
                        <span *ngIf="!jobData?.crequest?.name">Data Not Found</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <h5 class="mb-2 text-bold-500"><i class="ft-info mr-2"></i>
                Lead Info</h5>
                <div class="col-12">
                  <div class="table-responsive">
                    <table class="table table-borderless">
                      <tbody>
                        <tr>
                          <td>Lead Title:</td>
                          <td class="users-view-name">
                              <span>{{jobData?.leads?.title }}</span>
                              <span *ngIf="!jobData?.leads?.title">Data Not Found</span>
                          </td>
                        </tr>
                        <tr>
                          <td>Lead Type:</td>
                          <td class="users-view-name">
                              <span>{{jobData?.leads?.type?.displayname }}</span>
                              <span *ngIf="!jobData?.leads?.type?.displayname">Data Not Found</span>
                          </td>
                        </tr>
                        <tr>
                          <td>Source:</td>
                          <td class="users-view-name">
                              <span>{{jobData?.leads?.source.displayname }}</span>
                              <span *ngIf="!jobData?.leads?.source.displayname">Data Not Found</span>
                          </td>
                        </tr>
                        <tr>
                          <td>Lead Stage:</td>
                          <td class="users-view-name">
                              <span>{{jobData?.leads?.lead_stage?.displayname }}</span>
                              <span *ngIf="!jobData?.leads?.lead_stage?.displayname">Data Not Found</span>
                          </td>
                        </tr>
                        <tr>
                          <td>Lead Status:</td>
                          <td class="users-view-name">
                              <span>{{jobData?.leads?.lead_status?.displayname }}</span>
                              <span *ngIf="!jobData?.leads?.lead_status?.displayname">Data Not Found</span>
                          </td>
                        </tr>
                        <tr>
                          <td>Next Action:</td>
                          <td class="users-view-name">
                              <span>{{jobData?.leads?.next_action?.displayname }}</span>
                              <span *ngIf="!jobData?.leads?.next_action?.displayname">Data Not Found</span>
                          </td>
                        </tr>
                        <tr>
                          <td>Created By:</td>
                          <td class="users-view-name">
                              <span>{{jobData?.leads?.created_by?.name }}</span>
                              <span *ngIf="!jobData?.leads?.created_by?.name">Data Not Found</span>
                          </td>
                        </tr>
                        <tr>
                          <td>Last Updated By:</td>
                          <td class="users-view-name">
                              <span>{{jobData?.leads?.last_updatedby?.name }}</span>
                              <span *ngIf="!jobData?.leads?.last_updatedby?.name">Data Not Found</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
          </div>
        </div>
      </div>
      <!-- User detail ends -->
    </div>
  </div>
  <div _ngcontent-fdm-c126="" class="buy-now">
    <a _ngcontent-fdm-c126=""   (click)="back()" class="btn btn-danger">Back To Contracts</a>
  </div>
</section>
<!----- Job Payment Update Popup ----------->
<!-- <div>
	<ng-template #myModal let-modal>
		<div class="modal-header">
			<h4 class="modal-title">Transaction</h4>
			<button type="button" class="close" (click)="modal.dismiss()">
				<span>&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<form>
        <div class="form-group">
					<label>Amount</label>
					<input type="text" class="form-control" [(ngModel)]="payment_model.paid_amount" [ngModelOptions]="{standalone: true}">
				</div>
        <div class="form-group">
					<label>Payment Mode</label>
					<ng-select
            [items]="paymentMode"
            bindLabel="displayname"
            bindValue="_id"
            placeholder="Select Payment Mode"
            [(ngModel)]="selectedPaymentMode"
            [ngModelOptions]="{ standalone: true }"
            (change)="getPaymentModeId($event)"
          >
          </ng-select>
				</div>
        <div class="form-group">
					<label>Payment Status</label>
          <ng-select
          [items]="pamentStatusList"
          bindLabel="label"
          bindValue="name"
          placeholder="Select Status"
          [(ngModel)]="selectedPaymentStatus"
          [ngModelOptions]="{ standalone: true }"
        >
          </ng-select>
				</div>
        <div class="form-group">
					<label>Payment Notes</label>
					<input type="text" class="form-control" [(ngModel)]="payment_model.payment_notes" [ngModelOptions]="{standalone: true}">
				</div>
				<div class="form-group">
					<label>Next Payment Date</label>
					<input type="date" class="form-control" [(ngModel)]="payment_model.next_paymentdate"  [ngModelOptions]="{standalone: true}">
				</div>
			</form>
			
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
			<button type="button" class="btn btn-primary" (click)="updatePayment()">Submit</button>
		  </div>
	</ng-template>
</div> -->
<!----- Job Payment Popup ----------->
<!-- <div>
  <ng-template #myModalPayment let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Transaction</h4>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="top-content">
        <table *ngIf="payment_data">
          <tbody>
            <tr>
              <th>Net Amount :</th>
              <td>
                <span *ngIf="payment_data[0]?.job_id?.projectbudget">{{payment_data[0]?.job_id?.projectbudget}}</span>
              </td>
            </tr>
            <tr>
              <th>Paid Amount :</th>
              <td>
                <span class="bg-light-success" *ngIf="payment_data[0]?.total_paid">{{payment_data[0]?.total_paid}}</span>
              </td>
            </tr>
            <tr>
              <th>Pending Amount :</th>
              <td>
                <span class="bg-light-danger" *ngIf="payment_data[0]?.pendingAmount">{{payment_data[0]?.pendingAmount}}</span>
              </td>
            </tr>
            <tr>
              <th>Mode :</th>
              <td>{{payment_data[0]?.mode?.displayname}}</td>
            </tr>
            <tr *ngIf="enrolmentData?.net_fees !== enrolmentData?.paid_fee">
              <th>Next Payment Date :</th>
              <td>{{enrolmentData?.next_payment_date | date :'mediumDate'}}</td>
            </tr>
          </tbody>

        </table>
      </div>
      <hr>
      <form>
        <div class="form-group">
          <label>Amount</label>
          <input type="text" class="form-control" [(ngModel)]="payment_model.paid_amount"
            [ngModelOptions]="{standalone: true}">
        </div>
        <div class="form-group">
          <label>Payment Mode</label>
          <ng-select [items]="paymentMode" bindLabel="displayname" bindValue="_id" placeholder="Select Payment Mode"
            [(ngModel)]="selectedPaymentMode" [ngModelOptions]="{ standalone: true }"
            (change)="getPaymentModeId($event)">
          </ng-select>
        </div>
        <div class="form-group">
          <label>Payment Status</label>
          <ng-select [items]="pamentStatusList" bindLabel="label" bindValue="name" placeholder="Select Status"
            [(ngModel)]="selectedPaymentStatus" [ngModelOptions]="{ standalone: true }">
          </ng-select>
        </div>
        <div class="form-group">
          <label>Payment Notes</label>
          <input type="text" class="form-control" [(ngModel)]="payment_model.payment_notes"
            [ngModelOptions]="{standalone: true}">
        </div>
        <div class="form-group">
          <label>Next Payment Date</label>
          <input type="date" class="form-control" [(ngModel)]="payment_model.next_paymentdate"
            [ngModelOptions]="{standalone: true}">
        </div>
      </form>

    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="payment()">Submit</button>
    </div>
  </ng-template>
</div> -->
<!---- New Payment Popup  --------------->
<div>
  <ng-template #myModalPayment let-modal>
    <div class="modal-header">
      <h4 class="modal-title" *ngIf="!row_id">Add</h4>
      <h4 class="modal-title" *ngIf="row_id">Update</h4>

      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form>
        <!-- <div class="form-group">
          <label>Project Name</label>
          <ng-select [items]="contarct_List" bindLabel="name" bindValue="_id" placeholder="Select Name"
            [(ngModel)]="selected_contract" [ngModelOptions]="{ standalone: true }" (change)="getNameId($event)">
          </ng-select>
        </div> -->
        <div class="form-group" *ngIf="!isFixed">
          <label>Limit</label>
          <input type="number" class="form-control" [(ngModel)]="reports_modal.limit"
            [ngModelOptions]="{ standalone: true }" placeholder="Enter Limit">
        </div>
        <div class="form-group" *ngIf="!isFixed">
          <label>Hours</label>
          <input type="number" class="form-control" [(ngModel)]="reports_modal.hours"
            [ngModelOptions]="{ standalone: true }" placeholder="Enter Hours">
          <div *ngIf="reports_modal.hours>reports_modal.limit">
            <span class="text-danger">Hours should be less than limit</span>
          </div>
        </div>
        <div class="form-group" *ngIf="!isFixed">
          <label>Rate</label>
          <input type="number" class="form-control" [(ngModel)]="reports_modal.rate"
            [ngModelOptions]="{ standalone: true }" placeholder="Enter Rate">
        </div>

        <div class="form-group" *ngIf="!isFixed">
          <label>Completed</label>
          <input type="number" class="form-control" [(ngModel)]="reports_modal.completed"
            [ngModelOptions]="{ standalone: true }" placeholder="Enter Completed">
        </div>
        <div class="form-group">
          <label>Type</label>
          <ng-select [items]="type_List" bindLabel="name" bindValue="id" placeholder="Select type"
            [(ngModel)]="selected_type" [ngModelOptions]="{ standalone: true }">
          </ng-select>
        </div>
        <div class="form-group">
          <label>Payment Method</label>
          <ng-select [items]="paymentMode" bindLabel="displayname" bindValue="_id" placeholder="Select Payment Mode"
            [(ngModel)]="selectedPaymentMode" [ngModelOptions]="{ standalone: true }"
            (change)="getPaymentModeId($event)">
          </ng-select>
        </div>
        <div class="form-group">
          <label>Alert</label>
          <ng-select [items]="onAlert_List" bindLabel="name" bindValue="name" placeholder="Select Alert"
            [(ngModel)]="selectedOnAlert" [ngModelOptions]="{ standalone: true }">
          </ng-select>
        </div>
        <div class="form-group">
          <label>Payment Status</label>
          <ng-select [items]="pamentStatusList" bindLabel="label" bindValue="name" placeholder="Select Status"
            [(ngModel)]="selectedPaymentStatus" [ngModelOptions]="{ standalone: true }">
          </ng-select>
        </div>
        <div class="form-group">
          <label>Farming<span class="required_field">*</span></label>
          <ng-select [items]="usersList" bindLabel="name" bindValue="_id" placeholder="Select Farming"
            [(ngModel)]="selectedFarmingBy" [ngModelOptions]="{ standalone: true }" (change)="getFarmId($event)"
            #farmingBy="ngModel">
          </ng-select>
        </div>
        <div class="form-group" *ngIf="isFixed">
          <label>Amount</label>
          <input type="number" class="form-control" [(ngModel)]="reports_modal.fixed_amount"
            [ngModelOptions]="{ standalone: true }" placeholder="Enter Amount">
        </div>
        <div class="form-group">
          <label>Payment Date</label>
          <input type="date" class="form-control" [(ngModel)]="reports_modal.payment_date"
            [ngModelOptions]="{standalone: true}" [ngModel]="reports_modal.payment_date | date: 'yyyy-MM-dd'">
        </div>
        <div class="form-group" *ngIf="isFixed">
          <label>Next Payment Date</label>
          <input type="date" class="form-control" [(ngModel)]="reports_modal.next_paymentdate"
            [ngModelOptions]="{standalone: true}" [ngModel]="reports_modal.next_paymentdate | date: 'yyyy-MM-dd'">
        </div>
        <div class="form-group">
          <label>Notes</label>
          <input type="text" class="form-control" [(ngModel)]="reports_modal.notes"
            [ngModelOptions]="{standalone: true}" placeholder="Enter Notes">
        </div>
        <div class="form-group">
          <label>Admin Notes</label>
          <input type="text" class="form-control" [(ngModel)]="reports_modal.admin_notes"
            [ngModelOptions]="{standalone: true}" placeholder="Enter Admin Notes">
        </div>
      </form>

    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
      <button type="button" class="btn btn-primary" [disabled]="reports_modal.hours>reports_modal.limit"
        (click)="addPayment()">Submit</button>
    </div>
  </ng-template>
</div>